import React, { useEffect, useState } from "react"
import * as XLSX from "xlsx"
import engWork1403 from "../assets/seed/eng-work-1404.xlsx"
import { Alert, Tag } from "antd"
import { GlobalFormatNumber } from "common/global"

export const EngWorkReader = props => {
  const { naCode } = props
  const [rows, setRows] = useState([])
  const [result, setResult] = useState(null)

  // Load Excel file
  useEffect(() => {
    fetch(engWork1403)
      .then(res => res.arrayBuffer())
      .then(data => {
        const workbook = XLSX.read(data, { type: "array" })
        const sheet = workbook.Sheets[workbook.SheetNames[0]]
        const json = XLSX.utils.sheet_to_json(sheet, { header: 1 })
        setRows(json)
      })
      .catch(err => {
        console.error("Failed to load Excel file:", err)
      })
  }, [])

  // Search when rows and naCode are available
  useEffect(() => {
    if (!naCode || rows.length === 0) return

    const matchedRow = rows.find(
      row => row[0]?.toString().trim() === naCode.trim()
    )

    if (matchedRow) {
      setResult({ M: matchedRow[1], N: matchedRow[13] }) // Columns M and N
    } else {
      setResult({ M: null, N: null })
    }
  }, [naCode, rows])

  return (
    <>
      {result && (
        <>
          {result.M && <Alert
            className="mx-2 mt-1"
            message={`کارکرد1/4: ${GlobalFormatNumber(result.M )?? "یافت نشد"} ریال`}
            type="info"
          />}
          {result.N && 
            <Alert
            className="mx-2 mt-1"
            message={`کارکرددوپوندی: ${GlobalFormatNumber(result.N) ?? "یافت نشد"} ریال`}
            type="info"
          />}
        </>
      )}
    </>
  )
}
